import React from 'react';
import style from './style.module.scss';
import { IconType } from 'react-icons';
import { icons } from '../../lib/helpers/icons';
import { AppIconType } from '../../lib/typegen/app-icon-type';

export interface FooterButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	theme: 'exit' | 'language' | 'call';
	innerText: string;
}

export default function FooterButton({ type = 'button', theme, className, innerText, ...props }: FooterButtonProps) {
	let Icon: IconType;
	const modifiers: string[] = [];

	switch (theme) {
		case 'exit': {
			Icon = icons[AppIconType.CancelRoundedSolid];
			modifiers.push(style['button--exit']);
			break;
		}

		case 'language':
			Icon = icons[AppIconType.LanguageSolid];
			modifiers.push(style['button--language']);
			break;
		case 'call':
			Icon = icons[AppIconType.MdPhoneInTalk];
			modifiers.push(style['button--call']);
			break;
		default:
			throw new Error('Invalid theme');
	}

	return (
		<button type={type} className={[className, style.button, ...modifiers].join(' ')} {...props}>
			<Icon aria-hidden='true' className={style.button__icon} />
			<span className={style.button__text}>{innerText}</span>
		</button>
	);
}
